function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "b629f179-8ab2-4411-a7df-956765958247",
  x1: 344.9209,
  y1: 369.39721,
  x2: 505.39917,
  y2: 369.39721,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.53514,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Security on");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M601.69959,76.85442,331.99753,242.82491s0,342.31415,269.70206,529.031c269.70205-186.7168,269.70205-529.031,269.70205-529.031Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#3f3d56"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M603.30988,76.85442l-4.61029,2.83711V768.61826c1.531,1.08244,3.06152,2.16537,4.61029,3.2376,269.70205-186.7168,269.70205-529.031,269.70205-529.031Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#6c63ff",
  opacity: 0.04
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.7
}, React.createElement("polygon", {
  points: "366.106 347.068 416.949 393.674 479.977 302.75 505.399 323.935 416.949 436.044 344.921 355.542 366.106 347.068",
  fill: "url(#b629f179-8ab2-4411-a7df-956765958247)"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "378.106 349.868 419.349 387.674 477.777 301.75 498.399 318.935 419.349 422.044 360.921 356.742 378.106 349.868",
  fill: "#3ad29f"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M335.59008,114.06442a3.67459,3.67459,0,0,1-2.04748-4.441,1.766,1.766,0,0,0,.0799-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.7661,1.7661,0,0,0-.2039.3618,3.67461,3.67461,0,0,1-4.441,2.04749,1.766,1.766,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76564,1.76564,0,0,0,.3618.2039,3.67459,3.67459,0,0,1,2.04748,4.441,1.76611,1.76611,0,0,0-.0799.40755h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67459,3.67459,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.0799h0a1.84257,1.84257,0,0,0,1.22119-3.31044h0A1.7661,1.7661,0,0,0,335.59008,114.06442Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189.59008,439.06442a3.67459,3.67459,0,0,1-2.04748-4.441,1.766,1.766,0,0,0,.0799-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.7661,1.7661,0,0,0-.2039.3618,3.67461,3.67461,0,0,1-4.441,2.04749,1.766,1.766,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76564,1.76564,0,0,0,.3618.2039,3.67459,3.67459,0,0,1,2.04748,4.441,1.76611,1.76611,0,0,0-.0799.40755h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67459,3.67459,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.0799h0a1.84257,1.84257,0,0,0,1.22119-3.31044h0A1.7661,1.7661,0,0,0,189.59008,439.06442Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 748.39917,
  cy: 254,
  r: 6,
  fill: "#f55f44",
  opacity: 0.5
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 121.39917,
  cy: 683,
  r: 6,
  fill: "#f55f44",
  opacity: 0.5
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 850.39917,
  cy: 485,
  r: 6,
  fill: "#f55f44",
  opacity: 0.5
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M874.59008,143.06442a3.67459,3.67459,0,0,1-2.04748-4.441,1.766,1.766,0,0,0,.0799-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.7661,1.7661,0,0,0-.2039.3618,3.67461,3.67461,0,0,1-4.441,2.04749,1.766,1.766,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76564,1.76564,0,0,0,.3618.2039,3.67459,3.67459,0,0,1,2.04748,4.441,1.76611,1.76611,0,0,0-.0799.40755h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67459,3.67459,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.0799h0a1.84257,1.84257,0,0,0,1.22119-3.31044h0A1.7661,1.7661,0,0,0,874.59008,143.06442Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M974.59008,771.06442a3.67459,3.67459,0,0,1-2.04748-4.441,1.766,1.766,0,0,0,.0799-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.7661,1.7661,0,0,0-.2039.3618,3.67461,3.67461,0,0,1-4.441,2.04749,1.766,1.766,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76564,1.76564,0,0,0,.3618.2039,3.67459,3.67459,0,0,1,2.04748,4.441,1.76611,1.76611,0,0,0-.0799.40755h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67459,3.67459,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.0799h0a1.84257,1.84257,0,0,0,1.22119-3.31044h0A1.7661,1.7661,0,0,0,974.59008,771.06442Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.59008,249.06442a3.67459,3.67459,0,0,1-2.04748-4.441,1.766,1.766,0,0,0,.0799-.40754h0a1.84257,1.84257,0,0,0-3.31045-1.22119h0a1.7661,1.7661,0,0,0-.2039.3618,3.67461,3.67461,0,0,1-4.441,2.04749,1.766,1.766,0,0,0-.40754-.07991h0a1.84257,1.84257,0,0,0-1.22119,3.31045h0a1.76564,1.76564,0,0,0,.3618.2039,3.67459,3.67459,0,0,1,2.04748,4.441,1.76611,1.76611,0,0,0-.0799.40755h0a1.84257,1.84257,0,0,0,3.31045,1.22119h0a1.76637,1.76637,0,0,0,.2039-.3618,3.67459,3.67459,0,0,1,4.441-2.04749,1.766,1.766,0,0,0,.40754.0799h0a1.84257,1.84257,0,0,0,1.22119-3.31044h0A1.7661,1.7661,0,0,0,182.59008,249.06442Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#4d8af0",
  opacity: 0.5
});

var _ref16 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 79.39917,
  cy: 284,
  r: 6,
  fill: "#47e6b1",
  opacity: 0.5
});

var _ref17 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 853.39917,
  cy: 332,
  r: 6,
  fill: "#47e6b1",
  opacity: 0.5
});

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 583.39917,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), React.createElement("rect", {
  x: 753.69959,
  y: 66.10811,
  width: 3,
  height: 17,
  transform: "translate(659.50728 -746.69959) rotate(90)",
  fill: "#47e6b1"
}));

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 594.39917,
  y: 666,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), React.createElement("rect", {
  x: 764.69959,
  y: 732.10811,
  width: 3,
  height: 17,
  transform: "translate(1336.50728 -91.69959) rotate(90)",
  fill: "#47e6b1"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 26.39917,
  y: 702,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), React.createElement("rect", {
  x: 196.69959,
  y: 768.10811,
  width: 3,
  height: 17,
  transform: "translate(804.50728 512.30041) rotate(90)",
  fill: "#47e6b1"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("rect", {
  x: 709.39917,
  y: 396,
  width: 3,
  height: 17,
  fill: "#47e6b1"
}), React.createElement("rect", {
  x: 879.69959,
  y: 462.10811,
  width: 3,
  height: 17,
  transform: "translate(1181.50728 -476.69959) rotate(90)",
  fill: "#47e6b1"
}));

var _ref22 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "795.606 123.018 802.049 128.924 811.177 115.5 814.399 118.185 802.049 134.294 792.921 124.092 795.606 123.018",
  fill: "#47e6b1",
  opacity: 0.5
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 760.28981,
  y: 305.80003,
  width: 22.24232,
  height: 28.59727,
  transform: "translate(-182.12458 -35.97628) rotate(-2.22071)",
  fill: "#6c63ff"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M681.71009,405.45856s-30.779-14.70576-30.28646-2.00541,31.02521,21.05594,31.02521,21.05594Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#ffb9b9"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M698.59666,512.91906s-14.52107,35.54159-19.88626,61.18854-13.53608,60.94229-3.02582,85.97362,40.39191,98.59935,40.69972,106.53707-2.55946,15.99856,3.79071,15.75231,40.90677-11.12587,42.30963-15.95007-11.79-17.03205-11.79-17.03205L718.11733,647.30624,752.1068,580.801l24.51648,99.215,4.80184,123.82844s23.56691-7.27361,26.98824-1.04656c0,0,10.55875-14.71883,11.9-21.13057s-4.98653-128.59106-4.98653-128.59106,21.63236-139.16288,4.16937-138.4857S733.63268,473.40208,698.59666,512.91906Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#6c63ff"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M719.92877,776.02043s-16.10862,35.60315-17.63461,37.25225-12.02317,17.95548-4.08545,17.64767,26.68044-8.98427,40.47584-22.23868,31.98406-36.21877,30.335-37.74475-12.9466-5.85768-12.9466-5.85768Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#575a89"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M784.29239,795.78356s-.97192,15.937-3.90076,22.4103-2.55947,15.99857,5.37825,15.69076,28.45267-4.28321,28.45267-4.28321,1.21817-9.58682-.43093-11.11281-8.67647-18.74271-5.68607-23.62847S784.29239,795.78356,784.29239,795.78356Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#575a89"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M796.03561,278.60052s16.922,26.37263,23.51842,32.47656-11.9616,19.543-11.9616,19.543l-33.2153,4.46789s.41786-30.22489-1.29281-33.33842S796.03561,278.60052,796.03561,278.60052Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#ffb9b9"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M767.16508,313.10863s6.84267,12.4541,13.19285,12.20785,39.1961-14.2394,40.599-19.06359,10.87963,34.55659,10.87963,34.55659L751.465,482.25016,731.86045,468.701l9.49913-83.04479,7.80153-44.8206Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#6c63ff"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M823.92139,439.69215c-3.206,6.70666-5.20835,13.70047-4.9307,20.86031.01231.31753.02462.635.05282.95187.76057,14.69329,6.17341,31.68646,8.11534,44.04443,1.40908,8.86485,1.00808,15.33551-4.1797,16.85636-12.57723,3.66758,1.83379,6.28861-46.826,22.48493s-57.15159,2.21623-57.27471-.95886,6.89116-27.29605,5.24206-28.822-23.07442,19.974-29.54772,17.04512-.73874-19.05053-.73874-19.05053,14.58264-33.954,14.27483-41.89176,22.08942-45.37466,22.08942-45.37466L745.432,326.67085s5.85768-12.9466,13.73384-14.842,14.411,2.621,14.411,2.621L760.397,343.57977l-13.90546,51.417,2.32629,18.989s16.17018-34.01561,26.7905-47.1469,33.26379-44.21805,33.26379-44.21805,5.28646-17.83738,1.2957-23.16791c-3.99136-5.34632,16.64671-6.14662,25.4463,15.77118,4.66382,11.61641,12.23581,28.93925,16.97922,45.068,4.22682,14.28851,6.22343,27.646,2.03588,35.2811C848.229,407.2371,832.1292,422.56828,823.92139,439.69215Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#575a89"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M854.62926,395.57321c-6.40029,11.66389-22.50006,26.99507-30.70787,44.11894-2.14378-7.72348-4.75909-15.71476-4.75909-15.71476s-10.03082-53.66869,19.64-67.53872a19.85766,19.85766,0,0,1,13.79106,3.85344C856.8202,374.58062,858.81681,387.93813,854.62926,395.57321Z",
  transform: "translate(-170.30041 -66.10811)",
  opacity: 0.1
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M736.8432,392.19108l-25.15446,7.33517-34.926,1.35437-3.593,30.348,57.39783,4.13394S744.904,395.05836,736.8432,392.19108Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#575a89"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M777.861,494.23066s-33.65163,5.58313-25.971,15.70981,37.49194-.5198,37.49194-.5198Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#ffb9b9"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M819.04351,461.50433c.76057,14.69329,6.17341,31.68646,8.11534,44.04443-10.72016,10.14608-20.91438,19.09523-24.75621,19.24421-7.93772.30781-20.69963-.78724-25.4007.985s-7.4583-28.32954-7.4583-28.32954S772.34936,487.8,784.865,482.5449C793.31283,478.9897,809.506,469.34688,819.04351,461.50433Z",
  transform: "translate(-170.30041 -66.10811)",
  opacity: 0.1
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M838.43294,346.91341s26.86513-4.22164,25.41378,40.35271,2.83185,73.027-7.97315,81.39568-45.90258,46.29809-53.8403,46.6059-20.69964-.78723-25.40071.985-7.45829-28.32955-7.45829-28.32955,2.80572-9.64839,15.32138-14.90351,42.00182-23.8878,41.75558-30.238-7.4583-28.32954-7.4583-28.32954S808.7621,360.78344,838.43294,346.91341Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#575a89"
});

var _ref36 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 602.04517,
  cy: 216.59094,
  r: 34.95222,
  fill: "#ffb9b9"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M748.81137,232.60234a6.749,6.749,0,0,1-2.93882,1.47479,2.09717,2.09717,0,0,1-2.43029-1.68345c-.79968,1.65841-1.70192,3.42592-3.33461,4.27688s-4.15732.13741-4.39266-1.68864a7.706,7.706,0,0,1-1.77364,3.74392c-1.013.96584-2.85,1.20961-3.73439.12482.715,3.90745.27369,7.92586.49823,11.89184s1.2821,8.1705,4.27847,10.7784c4.36987,3.80334,10.94108,2.86467,16.68929,2.1441a5.06575,5.06575,0,0,1,2.61539.14308c2.15231.917,2.05467,3.9131,2.08369,6.25242a17.37277,17.37277,0,0,0,15.21221,16.4975,8.70861,8.70861,0,0,0,6.47244-1.57965c1.63206-1.38335,2.46572-3.638,4.33585-4.67723,3.04207-1.6904,6.73153.77486,8.95568,3.45157s4.4162,5.96934,7.86172,6.45932c4.55691.648,8.02766-3.996,9.73047-8.27217a48.223,48.223,0,0,0-.95837-37.46977C798.46709,223.729,765.96382,220.44839,748.81137,232.60234Z",
  transform: "translate(-170.30041 -66.10811)",
  fill: "#2f2e41"
});

var SvgUndrawSecurityOnFf2U = function SvgUndrawSecurityOnFf2U(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "f921693e-33a8-40f4-b606-3710578972cc",
    "data-name": "Layer 1",
    width: 859.39917,
    height: 767.78379,
    viewBox: "0 0 859.39917 767.78379",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawSecurityOnFf2U, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_Security_on_ff2u.741b7319.svg";
export { ForwardRef as ReactComponent };